<template>
  <div :class="[`support-info`, className || ``]">
    <h1 class="one-product-unlimit inter-semi-bold-link-water-40px">tu smo za vas</h1>
    <p class="inter-normal-gull-gray-18px">
       ukoliko imate pitanje ili posebne zahteve
    </p>
    <p class="inter-normal-gull-gray-18px">
      kontaktirajte nas
    </p>
    <p class="inter-normal-gull-gray-18px">
       <a href="mailto:support@protokol.io">support@protokol.io</a>
    </p>
    <p class="inter-normal-gull-gray-18px">
      <a href="tel:067 7580 435">067 7580 435</a>
    </p>
  </div>
</template>

<script>
export default {
  name: "SupportInfo",
  props: ["excepteurSintOccae", "className"],
};
</script>

<style>
.support-info {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  margin-top: 104px;
  position: relative;
  width: fit-content;
}

.one-product-unlimit {
  height: 69px;
  letter-spacing: -0.5px;
  line-height: 50px;
  margin-top: -1px;
  position: relative;
  text-align: center;
  width: 376px;
}

.excepteur-sint-occae-3 {
  height: 195.21px;
  min-width: 289.37px;
  position: relative;
}

.support-info.support-info-1 {
  left: 0;
  margin-top: unset;
  position: absolute;
  top: 1637px;
  width: 375px;
}

.support-info.support-info-1 .one-product-unlimit {
  margin-left: -0.5px;
  margin-right: -0.5px;
}
</style>
